import styled from "styled-components"

const SearchIcon = styled.i`
  font-size: 20px;
`
export default SearchIcon
